import { OpenBookProvider } from '@/pages/Bookstore/contexts/BookContext';
import {
  BookstoreModuleProvider,
  BookstoreModuleType,
} from '@/pages/Bookstore/contexts/BookstoreModuleContext';
import { MyBooksPage } from '@/pages/Bookstore/pages/MyBooks/MyBooks';
import { BookModal } from '@/pages/Bookstore/components/organisms/BookModal';
import { useTheme } from '@/contexts/ThemeProvider';

function BookstoreEmbed({ type }: { type: BookstoreModuleType }) {
  const { isNative } = useTheme();
  return (
    <BookstoreModuleProvider type={type}>
      <OpenBookProvider isNative={!!isNative}>
        <BookModal />
        <MyBooksPage />
      </OpenBookProvider>
    </BookstoreModuleProvider>
  );
}

export function BibliotecaPage() {
  return <BookstoreEmbed type="biblioteca" />;
}

export function BancaPage() {
  return <BookstoreEmbed type="banca" />;
}
